module.exports = __webpack_public_path__ + "img/vertical_3_6_7016.59ae5772.png";